export function convertFileToBase64(file: File): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.onload = (event) => {
      if (typeof event.target?.result === 'string') {
        resolve(event.target.result.split(',')[1])
      } else {
        reject()
      }
    }

    reader.onerror = reject
    reader.readAsDataURL(file)
  })
}
